import { Sparkles } from 'lucide-react';
import { motion } from 'motion/react';

interface ForYouBadgeProps {
  variant?: 'default' | 'large';
  animate?: boolean;
}

export function ForYouBadge({
  variant = 'default',
  animate = true,
}: ForYouBadgeProps) {
  const isLarge = variant === 'large';

  return (
    <motion.div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#D1FAE5',
        border: '1px solid rgba(5, 150, 105, 0.3)',
        borderRadius: '9999px', // Full pill shape
        paddingLeft: isLarge ? '10px' : '8px',
        paddingRight: isLarge ? '10px' : '8px',
        paddingTop: isLarge ? '6px' : '3px',
        paddingBottom: isLarge ? '6px' : '3px',
        minHeight: isLarge ? '32px' : '22px',
        flexShrink: 0,
      }}
      initial={animate ? { scale: 0.9, opacity: 0 } : undefined}
      animate={animate ? { scale: 1, opacity: 1 } : undefined}
      transition={
        animate
          ? {
              type: 'spring',
              stiffness: 500,
              damping: 20,
            }
          : undefined
      }
    >
      <Sparkles
        className={isLarge ? 'w-4 h-4' : 'w-3.5 h-3.5'}
        style={{
          color: '#059669',
          fill: '#059669',
          strokeWidth: 1.5,
          width: isLarge ? '16px' : '14px',
          height: isLarge ? '16px' : '14px',
        }}
      />
      <span
        style={{
          fontSize: isLarge ? 'var(--text-sm)' : 'var(--text-xs)',
          fontWeight: 'var(--font-weight-medium)',
          color: '#059669',
          lineHeight: 'normal',
        }}
      >
        Para você
      </span>
    </motion.div>
  );
}
